import { useEffect, useState, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import getRelatedSearchNavQuery from '../queries/related-search/getRelatedSearchNavQuery';
import { getProductQuery } from '../queries';
import DataProviderContext from '../react/DataProviderContext';
import { useQuery } from './useQuery';

const useRelatedSearchNav = ({
  navParam, skip = false, ssr = true, domains, productDomains, itemId, storeId
}) => {

  const ctx = useContext(ExperienceContext);
  const dpContext = useContext(DataProviderContext);

  const sId = storeId || dpContext.storeId || '8119';

  const opts = {
    skip,
    ssr,
    domains,
    productDomains,
    variables: {},
  };

  if (navParam) {
    opts.variables.navParam = navParam;
  }
  if (sId) {
    opts.variables.storeId = sId;
  }

  if (itemId) {
    opts.variables.itemId = itemId;
  }

  const Query = getRelatedSearchNavQuery({
    domains,
    productDomains
  });
  const resp = useQuery(Query, opts);

  return resp;
};

export default useRelatedSearchNav;
